import React from 'react';
import moment from 'moment';

import BootstrapTable from 'react-bootstrap-table-next';

import { InsightsOffCanvas } from '../InsightsOffCanvas';

import './InsightSettings.css';

export const AppointmentInsightHistoryTable = (data) => {
  let tableData = [];

  if (data.settings.length) {
    for (var i = 0; i < data.settings.length; i++) {
      tableData.push({
        id: data.settings[i].id,
        created_at: moment(data.settings[i].created_at).format('DD MMM YYYY'),
        insightSetting:
          data.settings[i].settings.changeInsight == 'Custom'
            ? `Every ${data.settings[i].settings.qty} ${data.settings[i].settings.frequency}`
            : (data.settings[i].settings.changeInsight ?? 'No insights needed'),
        insightChangedBy: data.settings[i].created_by_firstname
          ? data.settings[i].created_by_firstname +
            ' ' +
            data.settings[i].created_by_lastname
          : 'System default',
      });
    }
  } else {
    tableData.push({
      id: Math.random(),
      created_at: '',
      dosage: '',
      insightSetting: 'No insights needed',
      insightChangedBy: '',
    });
  }

  // Table Columns
  const columns = [
    {
      dataField: 'created_at',
      text: 'Date',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
    {
      dataField: 'insightSetting',
      text: 'Insight setting',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
    {
      dataField: 'insightChangedBy',
      text: 'Insight changed by',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
  ];

  let uKey = 0;

  // Rendering //
  // react-bootstrap-table2: https://react-bootstrap-table.github.io/react-bootstrap-table2/
  return data.settings.length > 0 ? (
    <>
      <div style={{ padding: '50px 0' }}>
        <div style={{ padding: '0px 11px 0px 11px', marginTop: '-70px' }}>
          <BootstrapTable
            bootstrap4
            keyField="id"
            wrapperClasses="table-responsive"
            id="insightTable"
            bordered={false}
            data={tableData}
            columns={columns}
            key={uKey++}
          />
        </div>
      </div>
      <InsightsOffCanvas />
    </>
  ) : (
    <></>
  );
};
